"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IceLanceAbilityHandler = exports.IceLanceActorAbilityFactory = exports.IceLanceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class IceLanceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.IceLance;
        this.__typeName = "IceLance";
    }
}
exports.IceLanceAbilityArgs = IceLanceAbilityArgs;
let IceLanceActorAbilityFactory = class IceLanceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("IceLance", "OneEnemies", 2);
    }
};
IceLanceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("IceLance")
], IceLanceActorAbilityFactory);
exports.IceLanceActorAbilityFactory = IceLanceActorAbilityFactory;
let IceLanceAbilityHandler = class IceLanceAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const focus = container.getAttributeScore(ability.invokerId, enums_1.AttributeType.Focus);
        const level = container.getLevel(ability.invokerId);
        const [targetId] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            projectilePath: "line",
            projectileType: "IceBeam",
            attackerId: ability.invokerId,
            targetId,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Frost", 80)
            ],
            onHit: sequence => {
                container.applyDebuffs({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    effects: [
                        {
                            duration: Duration_1.Duration.Ticks(8),
                            effect: new core_1.BleedingEffectArgs("Focus", 25)
                        }
                    ]
                });
            }
        });
    }
};
IceLanceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.IceLance)
], IceLanceAbilityHandler);
exports.IceLanceAbilityHandler = IceLanceAbilityHandler;
